import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { installMockImageHost } from './utils/mockImageHost'
import { installVendorAssetHost } from './utils/vendorAssets'

installMockImageHost()
installVendorAssetHost()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)